/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual Size Ruler (Online, cm & inches) — Toolverse`)
};

const es_ruler_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regla a Tamaño Real (Online, cm y pulgadas) — Toolverse`)
};

const de_ruler_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lineal in Originalgröße (Online, cm & Zoll) — Toolverse`)
};

const nl_ruler_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ware-grootte Liniaal (Online, cm & inches) — Toolverse`)
};

const fr_ruler_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Règle Taille Réelle (En Ligne, cm & pouces) — Toolverse`)
};

const it_ruler_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Righello a grandezza reale (online, cm e pollici) — Toolverse`)
};

const pt_br2_ruler_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Régua em Tamanho Real (Online, cm e polegadas) — Toolverse`)
};

const pt_ruler_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Régua em Tamanho Real (Online, cm e polegadas) — Toolverse`)
};

const ja_ruler_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実寸定規(オンライン、cm・インチ対応) — Toolverse`)
};

const zh_ruler_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`真实尺寸标尺（在线，厘米与英寸）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_meta_title", locale)
	if (locale === "en") return en_ruler_meta_title(inputs)
	if (locale === "es") return es_ruler_meta_title(inputs)
	if (locale === "de") return de_ruler_meta_title(inputs)
	if (locale === "nl") return nl_ruler_meta_title(inputs)
	if (locale === "fr") return fr_ruler_meta_title(inputs)
	if (locale === "it") return it_ruler_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_meta_title(inputs)
	if (locale === "pt") return pt_ruler_meta_title(inputs)
	if (locale === "ja") return ja_ruler_meta_title(inputs)
	return zh_ruler_meta_title(inputs)
};